import { NavBar as Base } from "@cancer-council-queensland/react";
import { renderStoryblokComponents } from "..";
import { jsx as _jsx } from "react/jsx-runtime";
export var NavBar = props => /*#__PURE__*/_jsx(Base, {
  header: renderStoryblokComponents(props.header),
  children: renderStoryblokComponents(props.children)
});
//# sourceMappingURL=nav_bar.js.map